<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div id="page-container" *ngIf="stateService?.getUser()?.authorities?.length > 0">
  <fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
  <div class="header-container">
    <h1 class="header-title">Scenario Selection</h1>
    <mat-divider></mat-divider>
  </div>
  <div id="scenario-container">
    <table>
      <tr>
        <td></td>
        <td class="working-scenario-content-border working-scenario-content-border-top column-header">
          <h2><b>Working Scenario</b></h2>
          <h3 *ngIf="!selectedVehicleScenario && !selectedIndustryScenario" style="font-style: italic">Select Scenario
            Below</h3>
        </td>
        <td class="column-header">
          <h2 [ngClass]="{'disabled-text': !selectedVehicleScenario}"><b>Compare Scenario</b></h2>
        </td>
      </tr>

      <!-- FORECAST ORG ROW -->
      <tr>
        <td class="scenario-labels">Forecast Organization</td>
        <td *ngIf="selectedIndustryScenario" class="working-scenario-content-border">
          <div class="column-content">
            <span class="column-text">
              {{ selectedVehicleScenario ? selectedVehicleScenario.fcorg : selectedIndustryScenario.forecastOrganization }}
            </span>
          </div>
        </td>
        <td *ngIf="compareVehicleScenario">
          <div class="column-content">
            <span class="column-text">{{ compareVehicleScenario.fcorg }}</span>
          </div>
        </td>
        <!-- if no selected scenarios -->
        <td *ngIf="!selectedIndustryScenario" class="working-scenario-content-border column-content"></td>
        <td *ngIf="!compareVehicleScenario"></td>
      </tr>

      <!-- VEHICLE SCENARIO ROW -->
      <tr class="light-gray-background">
        <td class="scenario-labels">Vehicle Scenario</td>
        <td *ngIf="selectedVehicleScenario"
            class="working-scenario-content-border">
          <div class="column-content">
            <span class="column-text pad-left-50">{{ selectedVehicleScenario.vehScenId }} - {{ selectedVehicleScenario.vehScenName }}</span>
            <button mat-icon-button [matMenuTriggerFor]="vehicleMenu" class="vertical-dots" matTooltip="More options">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #vehicleMenu="matMenu">
              <button mat-menu-item (click)="openVehSelectComponent()">
                <mat-icon>autorenew</mat-icon>
                <span>Change Scenario</span>
              </button>
              <mat-divider></mat-divider>

              <button mat-menu-item [matMenuTriggerFor]="forecastVehicleMenuOptions">
                <mat-icon>equalizer</mat-icon>
                <span>Vehicle Forecast</span>
              </button>
              <mat-menu #forecastVehicleMenuOptions="matMenu">
                <button mat-menu-item (click)="navToQueryVehicle()"
                        [disabled]="selectedVehicleScenario === undefined || selectedVehicleScenario === null">
                  Create Template
                </button>
                <button mat-menu-item (click)="navToQueryVehicleSave()">Save Template</button>
              </mat-menu>

              <button mat-menu-item [matMenuTriggerFor]="updateVehicleMenuOptions">
                <mat-icon>update</mat-icon>
                <span>Update</span>
              </button>
              <mat-menu #updateVehicleMenuOptions="matMenu">
                <button mat-menu-item
                        [disabled]="selectedVehicleScenario === undefined || selectedVehicleScenario === null || (selectedVehicleScenario.fcorg === GMTVP && stateService.isUserRole())"
                        (click)="onUpdateWithVehPortfolioClick()">
                  With Portfolio
                </button>

                <button mat-menu-item
                        *ngIf="stateService.isAdmin()"
                        [disabled]="!selectedVehicleScenario"
                        (click)="navToUpdateForecastWithScenario()">
                  With Other Scenario Forecast
                </button>

                <button mat-menu-item
                        *ngIf="stateService.isAdmin()"
                        [disabled]="!selectedVehicleScenario"
                        (click)="navToUpdateVehWithExtData()">
                  With External Data
                </button>

                <button *ngIf="stateService.isSystemAdminRole()" mat-menu-item
                        [disabled]="!selectedVehicleScenario"
                        (click)="navToDeleteVehDetails()">
                  Delete Vehicle Detail Records
                </button>
              </mat-menu>
            </mat-menu>
          </div>
        </td>
        <td *ngIf="compareVehicleScenario">
          <div class="column-content">
            <span class="column-text pad-left-50">{{ compareVehicleScenario.vehScenId }} - {{ compareVehicleScenario.vehScenName }}</span>
            <button mat-icon-button [matMenuTriggerFor]="compareVehicleMenu" class="vertical-dots"
                    matTooltip="More options">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #compareVehicleMenu="matMenu">
              <button mat-menu-item (click)="selectCompareScenario()">
                <mat-icon>autorenew</mat-icon>
                <span>Change Scenario</span>
              </button>
            </mat-menu>
          </div>
        </td>
        <!-- if no selected scenarios -->
        <td *ngIf="!selectedVehicleScenario" class="working-scenario-content-border column-content">
          <span class="hyperlink"
                tabindex="0"
                (click)="openVehSelectComponent()"
                (keydown.enter)="openVehSelectComponent()">Select Vehicle Scenario</span>
        </td>
        <td *ngIf="!compareVehicleScenario"></td>
      </tr>

      <!-- INDUSTRY SCENARIO ROW -->
      <tr>
        <td class="scenario-labels">Industry Scenario</td>
        <td *ngIf="selectedIndustryScenario"
            class="working-scenario-content-border">
          <div class="column-content">
            <span class="column-text pad-left-50">{{ selectedIndustryScenario.id }} - {{ selectedIndustryScenario.industryScenarioName }}</span>

            <button mat-icon-button [matMenuTriggerFor]="industryMenu" class="vertical-dots" matTooltip="More options">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #industryMenu="matMenu">
              <button mat-menu-item (click)="openIndSelectComponent()">
                <mat-icon>touch_app</mat-icon>
                <span>Select Industry Scenario</span>
              </button>
              <mat-divider></mat-divider>

              <button mat-menu-item [matMenuTriggerFor]="forecastIndustryMenuOptions">
                <mat-icon>equalizer</mat-icon>
                <span>Industry Forecast</span>
              </button>
              <mat-menu #forecastIndustryMenuOptions="matMenu">
                <button mat-menu-item (click)="openQueryIndustryPopUp()"
                        [disabled]="!selectedIndustryScenario">
                  Create Template
                </button>
                <button mat-menu-item (click)="navToQueryIndustrySave()">Save Template</button>
              </mat-menu>

              <button mat-menu-item [matMenuTriggerFor]="updateIndustryMenuOptions">
                <mat-icon>update</mat-icon>
                <span>Update</span>
              </button>
              <mat-menu #updateIndustryMenuOptions="matMenu">
                <app-update-scenario-with-segment-scheme
                  [industryScenario]="selectedIndustryScenario"
                  [isMenuItem]="true"
                  [disabled]="!selectedIndustryScenario || !stateService.isSystemAdminRole()">
                </app-update-scenario-with-segment-scheme>
              </mat-menu>
            </mat-menu>
          </div>
        </td>
        <td *ngIf="compareVehicleScenario">
          <div class="column-content">
            <span class="column-text">{{ compareVehicleScenario.industryScenario.id }} - {{ compareVehicleScenario.industryScenario.industryScenarioName }}</span>
          </div>
        </td>
        <!-- if no selected scenarios -->
        <td *ngIf="!selectedIndustryScenario" class="working-scenario-content-border column-content">
          <span class="hyperlink"
                tabindex="0"
                (click)="openIndSelectComponent()"
                (keydown.enter)="openIndSelectComponent()">Select Industry Scenario</span>
        </td>
        <td *ngIf="!compareVehicleScenario"></td>
      </tr>

      <!-- PROPULSION SCENARIO ROW -->
      <tr class="light-gray-background">
        <td class="scenario-labels">Propulsion Scenario</td>
        <td *ngIf="selectedVehicleScenario && selectedVehicleScenario.propulsionScenario.propulsionScenarioName"
            class="working-scenario-content-border working-scenario-content-border-bottom">
          <div class="column-content">
            <span
              class="column-text pad-left-50">{{ selectedVehicleScenario.propulsionScenario.id }} - {{ selectedVehicleScenario.propulsionScenario.propulsionScenarioName }}</span>

            <button mat-icon-button [matMenuTriggerFor]="propulsionMenu" class="vertical-dots"
                    matTooltip="More options">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #propulsionMenu="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="forecastPropulsionMenuOptions">
                <mat-icon>equalizer</mat-icon>
                <span>Propulsion Forecast</span>
              </button>
              <mat-menu #forecastPropulsionMenuOptions="matMenu">
                <button mat-menu-item (click)="navToCreatePropulsionForecastTemplate()"
                        [disabled]="!(selectedVehicleScenario && selectedVehicleScenario.propulsionScenario.propulsionScenarioName)">
                  Create Template
                </button>
                <button mat-menu-item (click)="navToSavePropulsionForecastTemplate()">Save Template</button>
              </mat-menu>
              <button mat-menu-item [matMenuTriggerFor]="updatePropulsionMenuOptions">
                <mat-icon>update</mat-icon>
                <span>Update</span>
              </button>
              <mat-menu #updatePropulsionMenuOptions="matMenu">
                <button mat-menu-item
                        [disabled]="selectedVehicleScenario ?
                selectedVehicleScenario.propulsionScenario.id === undefined || selectedVehicleScenario.propulsionScenario.id === null : true"
                        (click)="onUpdateWithPropPortfolioClick()">
                  With Portfolio
                </button>
                <button mat-menu-item
                        *ngIf="stateService.isAdmin()"
                        [disabled]="!selectedVehicleScenario"
                        (click)="navToUpdatePropForecastWithScenario()">
                  With Other Scenario Forecast
                </button>
                <button mat-menu-item
                        *ngIf="stateService.isAdmin()"
                        [disabled]="!selectedVehicleScenario"
                        (click)="navToUpdatePropWithExtData()">
                  With External Data
                </button>
                <button mat-menu-item
                        (click)="openAttachPropScenDialog()">
                  Change Propulsion Scenario
                </button>
                <button *ngIf="stateService.isSystemAdminRole()" mat-menu-item
                        (click)="navToDeletePropDetails()">
                  Delete Propulsion Detail Records
                </button>
              </mat-menu>
            </mat-menu>

          </div>
        </td>
        <!-- if selected scenario and no propulsion scenario-->
        <td *ngIf="selectedVehicleScenario && !selectedVehicleScenario.propulsionScenario.propulsionScenarioName"
            class="working-scenario-content-border working-scenario-content-border-bottom">
          <div class="column-content">
            <span class="hyperlink"
                  tabindex="0"
                  (click)="openAttachPropScenDialog()"
                  (keydown.enter)="openAttachPropScenDialog()">Attach Propulsion Scenario</span>
          </div>
        </td>
        <td *ngIf="compareVehicleScenario">
          <div class="column-content">
            <span class="column-text">{{ compareVehicleScenario.propulsionScenario.id }} - {{ compareVehicleScenario.propulsionScenario.propulsionScenarioName }}</span>
          </div>
        </td>
        <!-- if no selected scenarios -->
        <td *ngIf="!selectedVehicleScenario"
            class="working-scenario-content-border working-scenario-content-border-bottom column-content"></td>
        <td *ngIf="!compareVehicleScenario"></td>
      </tr>
    </table>
  </div>
</div>


